<template>
  <div id="microContainer" :class="{'micro-side-hide': !sideBarShow}">
    <Header :sideBarShow.sync="sideBarShow"/>
    <Sidebar class="sidebar-container" :sideBarShow.sync="sideBarShow"/>
    <!--<br><br><br><br>-->
    <!--<router-link to="/micro-container/eos-web#/appCenter">eos-web</router-link><br><br>-->
    <!--<router-link to="/micro-container/admin#/processData">素养管理后台</router-link><br><br>-->
    <router-view v-if="!iframeShowUrl"></router-view>
    <div id="microMain" v-if="!iframeShowUrl"></div>
    <iframe :src="iframeShowUrl" id="microIframe" frameborder="0" v-if="iframeShowUrl"></iframe>
  </div>
</template>

<script>
  import { loadMicroApp } from 'qiankun'
  // import MainFrame from './lvya-common/src/coms-web/layout/micro-frame/MainFrame'
  import MainFrame from './lvya-common/src/coms-web/layout/TMS-frame/MainFrame'
  import { Header, Sidebar, AppMain } from './lvya-common/src/coms-web/layout/TMS-frame/components'
  import Bus from './lvya-common/src/coms-web/layout/TMS-frame/eventBus'
  export default {
    components: {
      Header,
      Sidebar,
      MainFrame
    },
    data() {
      return {
        sideBarShow: true,
        iframeShowUrl: '',
      }
    },
    watch: {
      $route(data) {
        this.initSideBar()
      }
    },
    methods: {
      initSideBar() {
        // TODO 场景编辑页面需要隐藏左边导航 editScene/editScene
        if (this.$route.fullPath.includes('editScene/editScene')) {
          this.sideBarShow = false
        } else {
          this.sideBarShow = true
        }
      }
    },
    created() {
      // 非主应用 重定向到TMS首页
      if (location.href.includes('micro-container') == false) {
        this.$router.replace({ path: '/micro-container/eos-web#/TMS' })
      }
      this.initSideBar()
      const that = this
      Bus.$on('iframeShowUrl', function(bool) {
        that.iframeShowUrl = bool
      })
    }
  }
</script>

<style lang="less">
  @import "./less/frontend.less";
  #microMain{
    /*主体区域*/
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 50px);
    transition: margin-left .28s;
    margin-left: 180px;
    margin-top: 50px;
    position: relative;
    padding: 15px;
  }
  #microIframe {
    border: 0;
    height: calc(100vh);
    width: 100%;
    padding-top: 55px;
    padding-left: 180px;
    margin-bottom: -55px;
  }
  .micro-side-hide{
    #microMain, #microIframe{
      margin-left: 0;
    }
  }
</style>
